import './style/index.less';
import SmsMsgConfig from './SmsMsgConfig';
export default SmsMsgConfig;
